export { AlertComponent } from './alert.component';
export { AlertModule } from './alert.module';
export { AlertConfig } from './alert.config';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng2-bootstrap/alert/index.js
// module id = 713
// module chunks = 3